<template>
  <div class="p-h24 bg-bg f f-jc h-100p">
    <user-profiles-badge
      v-bind="badge"
      variant="store_listing"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  badge: {
    type: Object,
    required: true,
  },
});
</script>
